import { graphql } from "../__generated__/gql";

export const GET_METADATA = graphql(`
  query GetMetadata {
    metadata {
      dataPullDate
    }
  }
`);

export default GET_METADATA;
